// ============================================================================
// JARVISTRAVEL - PAGE VIEW TRACKING HOOK
// Version: 1.0.0
// Tracks route changes via react-router as Mixpanel page view events.
// ============================================================================

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/app/utils/analytics';

/**
 * Subscribe to react-router location changes and fire a Mixpanel "Page View"
 * event on every navigation.  Mount once at the app root.
 */
export function usePageViewTracking(): void {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const route = pathname + search;
    const title = document.title || undefined;
    trackPageView(route, title);
  }, [pathname, search]);
}
